import logoDark from "../assets/images/icons/logo-dark.svg";
import logoYellow from "../assets/images/icons/logoYellow.svg";

export const getLogoImage = (layoutMode) => {
    switch (layoutMode) {
      case "dark":
        return logoYellow;
      default:
        return logoDark; // Default image
    }
  };
  